import { useEffect, useState } from 'react'
import { CalendarCheck, Save } from 'lucide-react'
import { toast } from 'sonner'
import api from '@/services/api'
import { Button } from '@/components/ui/Button'
import type { Deal } from '@/types'
import { mapDealFromApi } from '@/adapters/deals'
import { getFriendlyError } from '@/utils/getFriendlyError'
import { formatDate } from '@/utils/format-date'
import { DatetimeLocalField } from './DatetimeLocalField'
import { toDatetimeLocalValue } from './reuniaoMeetingUtils'

export function DealWinDateSection({
  deal,
  onDealPatched,
}: {
  deal: Deal
  onDealPatched: (updates: Partial<Deal>) => void
}) {
  const [dataFechamento, setDataFechamento] = useState(() =>
    toDatetimeLocalValue(deal.dataFechamento),
  )
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    setDataFechamento(toDatetimeLocalValue(deal.dataFechamento))
  }, [deal.id, deal.dataFechamento])

  const handleSave = async () => {
    if (!dataFechamento) {
      toast.error('Informe a data do ganho')
      return
    }
    setSaving(true)
    try {
      const iso = new Date(dataFechamento).toISOString()
      const { data } = await api.patch(`/deals/${deal.id}`, { dataFechamento: iso })
      const updated = mapDealFromApi(data.data ?? data)
      onDealPatched(updated)
      toast.success('Data de ganho atualizada')
    } catch (err: unknown) {
      toast.error(getFriendlyError(err, 'Erro ao salvar data de ganho'))
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="glass-card space-y-3 p-4">
      <h3 className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-emerald-400">
        <CalendarCheck size={14} />
        Data de ganho
      </h3>
      <p className="text-[11px] text-text-label leading-relaxed">
        Registro atual:{' '}
        <strong className="text-text-primary">
          {deal.dataFechamento ? formatDate(deal.dataFechamento) : '—'}
        </strong>
        . Ajuste para refletir quando o contrato foi realmente assinado.
      </p>
      <DatetimeLocalField
        value={dataFechamento}
        onChange={setDataFechamento}
        placeholder="Data e hora do ganho"
      />
      <Button
        variant="secondary"
        size="sm"
        icon={<Save size={13} />}
        loading={saving}
        onClick={handleSave}
        className="w-full"
      >
        Salvar data de ganho
      </Button>
    </div>
  )
}
